import TacheFormEnteteController from './tache.form.entete.controller';

export default {
    bindings: {
        tache: '<',
        form: '=',
        onUpdate: '&'
    },
    template: require('./tache.form.entete.html'),
    controller: TacheFormEnteteController
};
